import type { WorkAreaId, WorkAreaWithStatus } from '@core/core/types'
import { createSelector } from '@reduxjs/toolkit'
import type { TabId } from 'common/types'

import type { RootState } from '../store'
import { workAreaAdapter } from './workAreaSlice'

export const { selectAll: selectAllWorkAreas, selectById: selectWorkAreaById } =
  workAreaAdapter.getSelectors<RootState>(state => state.workAreas)

export const selectActiveTab = (state: RootState) => {
  if (!state.workAreas.activeWorkAreaId) return

  const workArea = selectWorkAreaById(state, state.workAreas.activeWorkAreaId)
  return workArea?.tabs.find(area => area.id === workArea.activeTabId)
}

export const selectActiveWorkAreaId = (state: RootState) => state.workAreas.activeWorkAreaId
export const selectActiveTabIdInWorkArea = (state: RootState, workAreaId: WorkAreaId) => {
  return selectWorkAreaById(state, workAreaId)?.activeTabId
}

const selectAllTabs = createSelector([selectAllWorkAreas], workAreas =>
  workAreas.flatMap(area => area.tabs),
)

export const selectTabById = (state: RootState, tabId?: TabId) => {
  if (!tabId) return

  const tabs = selectAllTabs(state)
  return tabs.find(tab => tab.id === tabId)
}

export const selectAllWorkAreasWithStatus = createSelector(
  [selectAllWorkAreas, selectActiveWorkAreaId],
  (allWorkAreas, activeWorkAreaId): WorkAreaWithStatus[] => {
    return allWorkAreas.map(workArea => ({
      ...workArea,
      isActive: workArea.id === activeWorkAreaId,
    }))
  },
)

export const selectTabDomainType = createSelector(
  [(_, tabId?: TabId) => tabId, selectTabById],
  (tabId, tab) => {
    return tab?.domainType
  },
)
